import { db } from '@/shared/services/firebase'

const fetchQuestionnaires = async () => {
  try {
    const snapshot = await db.collection('messages')
      .where('type', '==', 'questionnaire')
      .orderBy('published', 'desc')
      .get()

    return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
  } catch (error) {
    throw new Error(error)
  }
}

const fetchQuestionnaire = async questionnaireId => {
  try {
    const doc = await db.collection('messages')
      .doc(questionnaireId)
      .get()

    if (!doc.exists) {
      throw new Error('Questionnaire not found')
    }
    return { ...doc.data(), id: doc.id }
  } catch (error) {
    throw new Error(error)
  }
}

const fetchAnswersByQuestionnaireId = async questionnaireId => {
  try {
    const snapshot = await db.collection('answers')
      .where('questionnaireId', '==', questionnaireId)
      .get()

    return await Promise.all(snapshot.docs.map(async doc => {
      const data = doc.data()
      const user = await db.collection('users')
        .doc(data.userId)
        .get()

      if (!user.exists) {
        return { ...data, id: doc.id }
      }

      return { ...data, id: doc.id, user: user.data() }
    }))
  } catch (error) {
    throw new Error(error)
  }
}

export {
  fetchQuestionnaires,
  fetchQuestionnaire,
  fetchAnswersByQuestionnaireId,
}
